import { useSearchParams } from "react-router-dom";
import { useMemo, useState } from "react";
import {Checkbox, Divider, Fade, IconButton} from "@mui/material";
import { Add, ExpandLess, ExpandMore, Remove } from "@mui/icons-material";
import { Aggregation } from "../../models/Aggregation";
import { fieldNameMapping } from "./types/field-name-mapping";

interface IAggregationProps {
  aggregation: Aggregation;
  lockedAggregations?: string[];
}

export const AggregationList = ({ aggregation, lockedAggregations=[] }: IAggregationProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(fieldNameMapping[aggregation.field].open);
  const [numVisible, setNumVisible] = useState(3);

  const checked = useMemo(
    () => {
      return [...searchParams.getAll(aggregation.field), ...lockedAggregations];
    },
    [searchParams, aggregation.field, lockedAggregations]
  );



  const selectAggs = (value: string) => {
    if (!checked.includes(value)) {
      searchParams.append(aggregation.field, value);
      searchParams.set("from", "0");
      setSearchParams(searchParams);
    } else {
      searchParams.delete(aggregation.field);
      searchParams.set("from", "0");
      checked
        .filter((c) => c !== value)
        .forEach((c) => searchParams.append(aggregation.field, c));
      setSearchParams(searchParams);
    }
  };

  const sortedBuckets = [...aggregation.buckets].sort((a, b) => {
      return a.key === "Project" ? -1 : (b.key === "Project" ? 1 : 0);
  })
  return (
    <li style={{ listStyle: "none" }}>
      <span
        style={{ display: "flex" }}
        onClick={() => {
          setOpen(!open);
          setNumVisible(5);
        }}
      >
        <IconButton disableRipple size="small">
          {open ? <Remove fontSize="inherit" /> : <Add fontSize="inherit" />}
        </IconButton>
        <h3>
          {" "}
          {`${fieldNameMapping[aggregation.field].name}` +
            (searchParams.getAll(aggregation.field).length > 0 ? ` (${searchParams.getAll(aggregation.field).length})` : "")}{" "}
        </h3>
      </span>

      <Fade in={open} unmountOnExit>
        <ul className="insideList">
          {sortedBuckets
            .filter((b) => checked.includes(b.key))
            .map((b) => (
              <li
                style={{ listStyle: "none" }}
                key={b.key}
                onClick={lockedAggregations?.includes(b.key) ? undefined : () => selectAggs(b.key)}
              >
                <div className="listItem">
                  <Checkbox
                    size="small"
                    color="secondary"
                    disabled={lockedAggregations?.includes(b.key)}
                    checked={checked.includes(b.key)}
                  />
                  <span> {b.key + " (" + b.doc_count + ")"} </span>{" "}
                </div>{" "}
              </li>
            ))}
          {sortedBuckets
            .filter((b) => !checked.includes(b.key))
            .slice(0, numVisible)
            .map((b) => (
                <>
              <li
                style={{ listStyle: "none" }}
                key={b.key}
                onClick={lockedAggregations?.includes(b.key) ? undefined : () => selectAggs(b.key)}
              >
                <div className="listItem">
                  <Checkbox
                    size="small"
                    color="secondary"
                    disabled={lockedAggregations?.includes(b.key)}
                    checked={checked.includes(b.key)}
                  />
                  <span> {b.key + " (" + b.doc_count + ")"} </span>{" "}
                </div>{" "}
              </li>
              {b.key === "Project" && <li style={{listStyle: "none"}}>  <Divider flexItem sx={{borderBottomWidth:"2px"}} orientation={"horizontal"} style={{marginBottom:"1rem"}}/></li>}
              </>
            ))}
          {aggregation.buckets.length > 3 ? (
            numVisible < aggregation.buckets.length ? (
              <div
                className="expand"
                onClick={() =>
                  numVisible > aggregation.buckets.length + 5
                    ? setNumVisible(aggregation.buckets.length)
                    : setNumVisible(numVisible + 5)
                }
                style={{
                  display: "flex",
                  paddingLeft: "1.75rem",
                  alignItems: "center",
                }}
              >
                <ExpandMore fontSize="inherit" /> <i> Show More </i>
              </div>
            ) : (
              <div
                className="expand"
                onClick={() => setNumVisible(3)}
                style={{
                  display: "flex",
                  paddingLeft: "1.75rem",
                  alignItems: "center",
                }}
              >
                <ExpandLess fontSize="inherit" /> <i> Show Less </i>
              </div>
            )
          ) : (
            <></>
          )}
        </ul>
      </Fade>
    </li>
  );
};
